export function makeid(length) {
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

export function flatten(items) {
    const flat = [];

    if (!Array.isArray(items)) return flat;

    items.forEach(item => {
        if (Array.isArray(item.rows)) {
            flat.push(...flatten(item.rows));
        }else{
            flat.push(item);
        }

    });

    return flat;
}

export function deselectAllRows(price) {
    price.rows.forEach(function (row) {
        row.isSelected = false;

        if (row.rows) {
            deselectAllRows(row);
        }
    });
}

// Make all external links open in new window
window.onload = function () {
    for (var tagArray = document.getElementsByTagName("a"), index = 0; index < tagArray.length; index++) {
        var b = tagArray[index];
        b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank") && (b.rel = "noopener")
    }
};
